import logo from './logo.svg';
import './App.css';
import React from 'react';
import Banner from './pf_gas';

function App() {
  return (
    <div className="App">
        <Banner/>
    </div>
  );
}

export default App;
